export type SurveyStatus = 'active' | 'ended' | 'not-started';

export enum QuestionnaireSection {
  Feedback = 'feedback',
  Strengths = 'strengths',
  Demographics = 'demographics',
  Benefits = 'benefits',
  CulturalQuestions = 'answers',
  DreamEmployerAnswers = 'dream_employer_answers',
  HappinessAnswers = 'happiness_answers',
  Complete = 'complete',
}
